module.exports = __webpack_public_path__ + "static/media/Teams-Small.76f7f90a.png";